import { normalize } from 'normalizr';

import toRecords from '../normalizers';
import { customerSchema } from '../schemas';

export function customer(responseData) {
  const data = normalize(responseData, customerSchema);

  return {
    ...toRecords(data),
  };
}
